import { useCallback, useState } from "react";
import { releaseNotesApi } from "api";
import { ReleaseNote } from "model/ReleaseNote";

const useReleaseNotes = () => {
  const [releaseNote, setReleaseNote] = useState<ReleaseNote | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchNote = useCallback(async (version: string, language: string) => {
    setLoading(true);
    setError(null);
    try {
      const { data } = await releaseNotesApi.get<ReleaseNote>(
        `releasenotes/${version}/${language}`
      );
      setReleaseNote(data);
    } catch (err: any) {
      if (err?.response?.status === 404) {
        setReleaseNote(null);
        return;
      }
      // setError(err?.message || "Failed to fetch release note");
      setReleaseNote(null);
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    releaseNote,
    loading,
    error,
    fetchNote,
  };
};

export default useReleaseNotes;
